import { Box } from '@stereograph/teia-system-design/components/Box';
import { Card, CardContent } from '@stereograph/teia-system-design/components/Card';
import { Stack } from '@stereograph/teia-system-design/components/Stack';
import { Text } from '@stereograph/teia-system-design/components/Typography';
import { useI18nDate } from '../../../../hooks/useI18nDate';
import { useAnomalyDocumentContext } from '../../context/AnomalyDocumentContext';
import { AnomalyDocumentBanner } from './AnomalyDocumentBanner';
import { AnomalyDocumentCardActions } from './AnomalyDocumentCardActions';

export interface AnomalyDocument {
  id: number;
  title: string;
  createdAt: Date;
  type: File['type'];
}

export const AnomalyDocumentCard = () => {
  const { anomalyDocument } = useAnomalyDocumentContext();
  const { format } = useI18nDate();

  return (
    <Card
      sx={{
        width: 160,
      }}
    >
      <CardContent
        sx={{
          'textAlign': 'center',
          '&:hover .actions': {
            opacity: 1,
            visibility: 'visible',
          },
        }}
      >
        <Stack spacing={2}>
          <Box
            sx={{
              position: 'relative',
            }}
          >
            <AnomalyDocumentCardActions />
            <AnomalyDocumentBanner />
          </Box>
          <div>
            <Text
              bold
              variant="body2"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {anomalyDocument.title}
            </Text>
            <Text variant="body2">{format(anomalyDocument.createdAt)}</Text>
          </div>
        </Stack>
      </CardContent>
    </Card>
  );
};
